import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";

export default function Login() {
    const { login } = useAuth();
    const { t } = useLang();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        const r = await login(email, password);
        setBusy(false);
        if (r.ok) {
            toast.success(t("auth.welcomeBack"));
            nav("/community");
        } else {
            setErr(r.error);
        }
    };

    return (
        <div data-testid="login-page" className="min-h-[80vh] max-w-md mx-auto px-5 py-20">
            <p className="text-xs tracking-[0.3em] uppercase text-abnormal-acid font-bold mb-4">{t("auth.loginEyebrow")}</p>
            <h1 className="font-display text-6xl uppercase leading-none">{t("auth.loginTitle")}</h1>
            <p className="text-zinc-400 mt-4">{t("auth.loginSub")}</p>

            <form onSubmit={submit} className="mt-10 space-y-4" data-testid="login-form">
                <div>
                    <label className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-bold">{t("auth.email")}</label>
                    <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                        className="mt-1 w-full bg-abnormal-charcoal border border-white/10 focus:border-abnormal-acid outline-none px-4 py-3" />
                </div>
                <div>
                    <label className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-bold">{t("auth.password")}</label>
                    <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                        className="mt-1 w-full bg-abnormal-charcoal border border-white/10 focus:border-abnormal-acid outline-none px-4 py-3" />
                </div>
                {err && <p data-testid="login-error" className="text-sm text-abnormal-acid">{err}</p>}
                <button data-testid="login-submit" type="submit" disabled={busy}
                    className="w-full bg-abnormal-acid text-black uppercase tracking-wider font-bold py-3 hover:bg-abnormal-paper hover:text-black transition-colors disabled:opacity-60">
                    {busy ? t("auth.loginBusy") : t("auth.loginBtn")}
                </button>
            </form>

            <p className="text-sm text-zinc-500 mt-6">
                <Link to="/forgot-password" data-testid="login-forgot-link" className="text-abnormal-acid uppercase tracking-wider font-bold">{t("auth.forgot")}</Link>
            </p>
            <p className="text-sm text-zinc-500 mt-3">
                {t("auth.noAccount")}{" "}
                <Link to="/register" className="text-abnormal-acid uppercase tracking-wider font-bold">{t("auth.goRegister")}</Link>
            </p>
        </div>
    );
}
